import React, { useState, useEffect, useRef } from 'react';
import classNames from 'classnames';
import { useHistory } from 'react-router-dom';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { Toolbar } from 'primereact/toolbar';
import { InputNumber } from 'primereact/inputnumber';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';

import api from './../../service/api';
import { formatDate, formatCurrency } from './../../service/format';
import { downloadCsv } from '../../service/handle';

const Stock = () => {
    let emptyStock = {
        product: '',
        quantity: null
    };

    const history = useHistory();

    const [stocks, setStocks] = useState([]);
    const [stockMovement, setStockMovement] = useState([]);
    const [stockDialog, setStockDialog] = useState(false);
    const [deleteStockDialog, setDeleteStockDialog] = useState(false);
    const [stock, setStock] = useState(emptyStock);
    const [selectedStocks, setSelectedStocks] = useState(null);
    const [submitted, setSubmitted] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const [globalFilter, setGlobalFilter] = useState(null);
    const toast = useRef(null);
    const dt = useRef(null);

    const onInputChange = (e, name) => {
        const val = (e.target && e.target.value) || '';
        let _stock = { ...stock };
        _stock[`${name}`] = val;

        setStock(_stock);
    }

    const openNew = () => {
        setStock(emptyStock);
        setSubmitted(false);
        setStockDialog(true);
        setDisabled(false);
    }

    const hideDialog = () => {
        setSubmitted(false);
        setStockDialog(false);
        setDisabled(false);
    }

    const hideDeleteStockDialog = () => {
        setDeleteStockDialog(false);
    }
    

    const handleStock = () => {
        if(!stock.product === '' || !stock.quantity === '')
            return setSubmitted(true);
        
        setSubmitted(false);
        setDisabled(true);

        api().post('/stock/create', stock).then(response => {
            if(response.status === 200 && response.data.result){
                toast.current.show({severity: 'success', summary: 'Sucesso', detail: response.data.message});
                listStocks();
                listMovement();
                hideDialog();
            } else {
                toast.current.show({severity: 'warn', summary: 'Atenção', detail: response.data.message});
                setDisabled(false);
            }
        });
    }

    const confirmDeleteStock = (stock) => {
        setStock({ ...stock });
        setDeleteStockDialog(true);
    }

    const handleDeleteStock = () => {
        setDeleteStockDialog(false);
        api().delete('/stock/' + stock.code).then(response => {
            if(response.status === 200 && response.data.result) {
                toast.current.show({severity: 'success', summary: 'Sucesso', detail: response.data.message});
                listStocks();
            } else toast.current.show({severity: 'error', summary: 'Erro', detail: response.data.message});
            setStock(emptyStock);
        });
    }

    const listStocks = () => {
        api().get('/stock/list').then(response => {
            if(response.status === 200 && response.data.result){
                setStocks(response.data.data);
            }
        });
    }

    const listMovement = () => {
        api().get('/stock/movement/list').then(response => {
            if(response.status === 200 && response.data.result){
                setStockMovement(response.data.data);
            }
        });
    }

    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <div className="my-2">
                    <Button label="Novo Produto" icon="pi pi-plus" className="p-button-success mr-2" onClick={openNew} />
                </div>
            </React.Fragment>
        )
    }

    const actionBodyTemplate = (rowData) => {
        return (
            <div className="actions">
                <Button icon="pi pi-arrow-up-right" className="p-button-rounded p-button-info mr-2" onClick={() => {
                    history.push('stock/list/' + rowData.code);
                }} />
                <Button icon="pi pi-trash" className="p-button-rounded p-button-danger mt-2" onClick={() => confirmDeleteStock(rowData)} />
            </div>
        );
    }

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">Gerenciar Estoque</h5>
            <span className="block mt-2 md:mt-0 p-input-icon-left">
                <i className="pi pi-search" />
                <InputText type="search" onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Pesquisar..." />
            </span>
        </div>
    );

    const headerInOut = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">Últimas 5 movimentações</h5>
        </div>
    );

    const deleteStockDialogFooter = (
        <>
            <Button label="Não" icon="pi pi-times" className="p-button-text" onClick={hideDeleteStockDialog} />
            <Button label="Sim" icon="pi pi-check" className="p-button-text" onClick={handleDeleteStock} />
        </>
    );

    const formatColumnType = (rowData, text) => {
        return (<span style={{color: rowData.type === 'Entrada' ? 'var(--green-400)' : '#f33030' }}>{text}</span>)
    }

    const productDialogFooter = (
        <>
            <Button label="Cancelar" disabled={disabled} icon="pi pi-times" className="p-button-text" onClick={hideDialog} />
            <Button label="Salvar" onClick={handleStock} loading={disabled} icon="pi pi-check" className="p-button-text"  />
        </>
    );

    const [loadingExport, setLoadingExport] = useState(false);
    const rightButton = () => (
        <>
            <Button label="Exportar" icon="pi pi-download" loading={loadingExport} className="p-button-text" onClick={() => {
                setLoadingExport(true);
                downloadCsv(['Produto', 'Quantidade', 'Última edição'], stocks.map(data => {
                    var dateOptions = {
                        year: 'numeric',
                        month: 'numeric',
                        day: 'numeric',
                        hour: 'numeric',
                        minute: 'numeric',
                        second: 'numeric',
                    }
                    return [
                        data.product,
                        data.quantity,
                        data.editedat ? new Date(data.editedat).toLocaleDateString('pt-br', dateOptions) : '-',
                    ];
                }), 'Estoque_' + Date.now());
                setTimeout(() => {
                    setLoadingExport(false)
                }, 3000);
            }} />
        </>
    );

    useEffect(() => {
        listStocks();
        listMovement();
    }, []);
  
    return (
        <div className="grid crud-demo">
            
            <div className="col-12">
                <div className="card">
                    <Toast ref={toast} />
                    <Toolbar className="mb-4" left={leftToolbarTemplate} right={rightButton}></Toolbar>

                    <DataTable ref={dt} value={stocks} selection={selectedStocks} onSelectionChange={(e) => setSelectedStocks(e.value)}
                        dataKey="id" paginator rows={10} rowsPerPageOptions={[5, 10, 25]} className="datatable-responsive"
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        currentPageReportTemplate="Listando {first} a {last} de {totalRecords} registros"
                        globalFilter={globalFilter} emptyMessage="Nenhum registro encontrado." header={header} responsiveLayout="scroll">
                        <Column selectionMode="multiple" headerStyle={{ width: '3rem'}}></Column>
                        <Column field="product"  header="Produto" sortable headerStyle={{ width: '24%', minWidth: '10rem' }}></Column>
                        <Column field="quantity" body={rowData => (formatCurrency(rowData.quantity))} header="Quantidade" sortable></Column>
                        <Column field="editedat" body={rowData => (rowData.editedat ? formatDate(rowData.editedat) : '-')} header="Última alteração" sortable></Column>
                        <Column body={actionBodyTemplate}></Column>
                    </DataTable>

                    <Dialog visible={stockDialog} style={{ width: '450px' }} header="Novo Produto" modal className="p-fluid" footer={productDialogFooter} onHide={hideDialog}>
                        
                        <div className="field">
                            <label htmlFor="name">Nome do Produto</label>
                            <InputText disabled={disabled} id="product" value={stock.product} onChange={(e) => onInputChange(e, 'product')} required autoFocus className={classNames({ 'p-invalid p-error': submitted && !stock.product })} />
                            {submitted && !stock.product && <small className="p-invalid p-error">O nome do produto é obrigatório.</small>}
                        </div>

                        <div className="formgrid grid">
                            <div className="field col">
                                <label htmlFor="quantity">Quantidade</label>
                                <InputNumber disabled={disabled} id="quantity" currency='BRL' maxFractionDigits={2}  mode='decimal' value={stock.quantity} onValueChange={(e) => onInputChange(e, 'quantity')}  />

                            </div>
                        </div>
                    </Dialog>

                    <Dialog visible={deleteStockDialog} style={{ width: '450px' }} header="Atenção" modal footer={deleteStockDialogFooter} onHide={hideDeleteStockDialog}>
                        <div className="flex align-items-center justify-content-center">
                            <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                            {stock && <span>Você tem certeza que deseja remover este produto?</span>}
                        </div>
                    </Dialog>
                    
                </div>
            </div>

            <div className="col-12">
                <div className='card'>
                    <DataTable ref={dt} value={stockMovement} 
                        dataKey="idInout" className="datatable-responsive"
                        emptyMessage="Nenhum registro encontrado." header={headerInOut} responsiveLayout="scroll">
                        <Column field="product"  header="Produto" sortable headerStyle={{ width: '24%', minWidth: '10rem' }}></Column>
                        <Column field="type" body={rowData => formatColumnType(rowData, rowData.type)} header="Tipo" headerStyle={{ width: '24%', minWidth: '10rem' }}></Column>
                        <Column field="quantity" body={rowData => formatColumnType(rowData, formatCurrency(rowData.quantity))} header="Quantidade"></Column>
                        <Column field="createdat" body={rowData => (rowData.createdat ? formatDate(rowData.createdat) : '-')} header="Última alteração"></Column>
                    </DataTable>
                </div>
            </div>
        </div>
    );
}

export default Stock;